$(document).ready(function () {

	if( !document.URL.includes('pages/favourites') ) {
		updateFavourites();
	}

	$(document).on('click', '#favourite', function(e) {
		e.preventDefault();
		var productData = $(this).data('product-favourite');
		var quickBuyDataEle = $('[data-favourite-colors]');
		const quickBuyData = JSON.parse(quickBuyDataEle.html());
		var productColours = quickBuyData.colors;
		productData.colors = productColours;

		favouriteItem(productData);

		return false;
	});
});

// ====================================== //
// Favourites Page and Functionality
// ====================================== //

// Function that saves the handle of the product to a favourites
// jSON object in the localstorage
function favouriteItem( $item ) {

	// Check if a favourites list already exists in local storage
	$favourites = localStorage.getItem('favourites');

	if(!$favourites) {
		// Create a new favourites list with the product ID
		$favourites = [$item];

		// Save the new list to local storage
		localStorage.setItem('favourites', JSON.stringify($favourites));
		showToast('Product added to your favourites!');

		return updateFavourites();
	}

	// Parse the existing favourites list
	$favourites = JSON.parse($favourites);

	// Check if the product ID is already in the favourites list
    $favouritesHandles = $favourites.map((product) => product.handle);

	if ($favouritesHandles.includes($item.handle)) {
		return removeFavourite($item, $favourites);	
	}

	// Add the product ID to the list
	$favourites.push($item);

	// Save the updated list back to local storage
	localStorage.setItem('favourites', JSON.stringify($favourites));

	showToast('Product added to your favourites!');

	return updateFavourites();
}

// Function to update product item classes based on local storage
function updateFavourites() {

	console.log('updating');

	if( !document.URL.includes('pages/favourites') ) {
		// Get favourites from local storage
		$favourites = localStorage.getItem('favourites');
		$favourites = JSON.parse($favourites);

		const productItems = $('.product-item');

		if( !$favourites || $favourites.length === 0 ) {
			// If no favourites exist, remove all favourite classes
			$(productItems).each(function(item) {
				var favouriteButton = $(this).find('#favourite');
				favouriteButton.removeClass('favourite');
			});
			return;
		}
		
		// Update button styles
		$(productItems).each(function() {
			let favouriteButton = $(this).find('#favourite');
			const productData = favouriteButton.data('product-favourite'); 

			updateFavouritesButton(productData, favouriteButton, $favourites);
		});

		$singleProduct = $('.product-page-favourite');
		if( $singleProduct.length ) {
			return updateSingleProduct($favourites);
		}
	}
}

function updateFavouritesButton(productData, favouriteButton, $favourites) {

	favouriteButton.removeClass('favourite');
    $favouritesHandles = $favourites.map((product) => product.handle);

	// Check if product ID is in favourites
	if ($favouritesHandles.includes(productData.handle)) {
		favouriteButton.addClass('favourite');
	} 

	// Update text if necessary
	$favText = $('#favText');
	if ($favText && $favouritesHandles.includes(productData.handle)) {
		$favText.text('Favourited');
	} else {
		$favText.text('Favourite');
	}
}

// Function to update product item classes based on local storage on a single product
function updateSingleProduct($favourites) {
	const favouriteButton = $('#favourite');
	let productData = $(favouriteButton).data('product-favourite');
	
	updateFavouritesButton(productData, favouriteButton, $favourites);
}

//
function removeFavourite(productData, $favourites) {
    
	const isAlreadyFavourite = $favourites.some(product => product.handle === productData.handle);

	if(isAlreadyFavourite) {
		$favourites = $favourites.filter(product => product.handle !== productData.handle);
	}
    // Update local storage
    localStorage.setItem('favourites', JSON.stringify($favourites));

	// Show alert
	showToast('Product removed from your favourites!'); 

	// Update the look of the buttons
	updateFavourites();
}

function removeFavouritePage(productHandle) {

	$favourites = localStorage.getItem('favourites');
	$favourites = JSON.parse($favourites);

	const isAlreadyFavourite = $favourites.some(product => product.handle === productHandle);

	if(isAlreadyFavourite) {
		$favourites = $favourites.filter(product => product.handle !== productHandle);
	}

	// Update local storage
    localStorage.setItem('favourites', JSON.stringify($favourites));

	// Count favourites so we can add div if they remove all products
	const favouritesCount = $favourites.length;
	if( favouritesCount === 0 ) {
		$('#noProducts').removeClass('tw-hidden');
		return;
	}

	// Show alert
	showToast('Product removed from your favourites!');
}

// Function that loads the favourites in from the local storage to the page
async function loadFavouritesPage() {
	$favourites = localStorage.getItem('favourites');
	const $favouritesContainer = $('#favourites-container');
	$favourites = JSON.parse($favourites);

	if (!$favourites || $favourites.length === 0 ) {
		$('#loading-block').addClass('hidden');
		$('#noProducts').removeClass('tw-hidden');
		return;
	}

	populateFavourites($favouritesContainer, $favourites);

	checkSwatches();

	// Clear the container before appending new divs
	$('#loading-block').addClass('hidden');

}

function populateFavourites($favouritesContainer, $favourites) {

	// Get the product template HTML
	const $template = $('#favouriteModal');

	$favourites.forEach(product => {

		// Clone the product template
		const $productDiv = $template.clone();
		
		//
		$('[data-modal-body]', $productDiv).removeClass('hidden');

		// Set where each item needs to be
		const $productTitle = $('h4[data-product-title]', $productDiv);
		const $productPrice = $('span[data-product-price]', $productDiv);
		const $productLink = $('[data-product-link]', $productDiv);
		const $productImagePlaceholder = $(
			'[data-placeholder="product-image"]',
			$productDiv
		);
		const $productImage = $('img[data-product-image]', $productDiv);

		// Favourites Button
        const $favouriteButton = $('[data-favourite]', $productDiv);
        $favouriteButton.attr('data-product-handle', product.handle);

		// Attach click event listener for removal
        $favouriteButton.on('click', function() {
			removeFavouritePage($(this).data('product-handle'));
			$favouriteButton.removeClass('favourite');
			$productDiv.remove();
        });

		// Product Image
		$productImagePlaceholder.addClass('tw-hidden');
		$productImage.attr('src', product.featuredImage);

		// Product Title
		$('[data-content]', $productTitle).html(product.title);
		$('[data-product-url]', $productTitle).attr('href', product.url);

		// Product Price
		$('[data-content]', $productPrice).html(product.price);

		// Product shop now link
		$('[data-product-url]', $productLink).attr('href', product.url);

		// Product Colour Options
		populateProductColorOptions({ modal: $productDiv, colors: product.colors, isEmpty: false });

		// Append the more colours button if needed
		var moreColours = '<span class="moreColours closed tw-hidden"><span class="open">+</span><span class="close">-</span></span>';
		$('[data-content="colors"]', $productDiv).append(moreColours);


		// Append the populated product div to the favourites div
		$favouritesContainer.prepend($productDiv);

	});

}

function showToast(message) {
	var toast = document.getElementById("toast");
	var toastMessage = document.getElementById("toast-message");
	toastMessage.textContent = message;
	toast.className = "toast show";
	setTimeout(function() { toast.className = toast.className.replace("show", ""); }, 3000);
  }

function initializeFavourites() {
	loadFavouritesPage();
}